<template>
 <v-dialog v-model="dialogGroupMember" persistent style="overflow-y: hidden;">
  <v-card >
  <v-card tile style="box-shadow: none !important;">
      <v-toolbar card style="background: #2562af !important;">
        <v-btn dark icon flat @click="clearState_back()" v-if="state=='editinvite'">
          <v-icon style="color: white !important; font-size: 20px !important;">chevron_left</v-icon>
        </v-btn>
        <v-toolbar-title class="white--text CSChatThai" v-if="state=='show'">ข้อมูลในกลุ่ม</v-toolbar-title>
        <v-toolbar-title class="white--text CSChatThai" v-else>เพิ่มเพื่อนเข้ากลุ่ม</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn dark icon flat @click="closeDialog()">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
  <v-card-text v-if="state=='show'"  style="height: 80vh; overflow: scroll;">
    <div style="display: inline;">
    <span style="margin-bottom: 2px;">สมาชิก ({{groupMember.length}})</span>

        <v-btn icon small flat @click="changestate()" style="margin: 0 !important; float: right;">
          <v-icon style="color: black !important; font-size: 20px !important;margin: 0 !important;">fas fa-plus-circle</v-icon>
        </v-btn>
  </div>

    <v-list v-if="groupMember.length != 0" >

<template v-for="(item, index) in groupMember" style="height: 50px;">
      <v-list-tile avatar @click="">
        <v-list-tile-avatar color="#2562af" size="40">
          <img :src="backend + item.user.profile_picture" v-if="item.user.profile_picture" class="alligator-turtle"/>
          <span class="white--text headline" v-else>{{(item.user.display_name.length>=2)? item.user.display_name.charAt(0)+item.user.display_name.charAt(1):item.user.display_name.charAt(0)}}</span>

        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title class="CSChatThai NameBorder" >
            {{item.user.display_name}} 
          </v-list-tile-title>
        </v-list-tile-content>


        <v-list-tile-action v-if="item.user.user_id != user_id">
                              <v-btn icon flat @click="removeFriendGroup(item.user.user_id)">
          <v-icon style="font-size: 20px !important;">clear</v-icon>
        </v-btn>
        </v-list-tile-action>

      </v-list-tile>
      <v-divider v-if="index != groupMember.length -1"></v-divider>
    </template>
    </v-list>





    <p style="margin-bottom: 2px;margin-top: 6px;">รอการยืนยัน ({{pendingMember.length}})</p>
    <v-list v-if="pendingMember.length != 0" >

<template v-for="(item, index) in pendingMember" style="height: 50px;">
      <v-list-tile avatar @click="">
        <v-list-tile-avatar color="#2562af" size="40">
          <img :src="backend + item.user.profile_picture" v-if="item.user.profile_picture" class="alligator-turtle"/>
          <span class="white--text headline" v-else>{{(item.user.display_name.length>=2)? item.user.display_name.charAt(0)+item.user.display_name.charAt(1):item.user.display_name.charAt(0)}}</span>

        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title class="CSChatThai NameBorder" v-text="item.user.display_name"></v-list-tile-title>
        </v-list-tile-content>

 <v-list-tile-action>
                              <v-btn icon flat @click="removePendingFriendGroup(item.user.user_id)">
          <v-icon style="font-size: 20px !important;">clear</v-icon>
        </v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider v-if="index != pendingMember.length -1"></v-divider>
    </template>
    </v-list>



    </v-card-text>

    <v-card-text v-else-if="state=='editinvite'"  style="max-height: 80vh; overflow: scroll;">

<div style="padding: 10px; cursor: pointer;background: #fafafa;">
<v-layout row wrap>
  <v-flex xs12 xl12 lg12 md12 sm12>
      <v-text-field
              solo
              placeholder="ค้นหาเพื่อน"
              prepend-inner-icon="fas fa-search"
              hide-details
              height="35"
              v-model="searchText"
              @input="searchUser()"
            ></v-text-field>
    </v-flex>
      <v-flex xs12 xl12 lg12 md12 sm12>
         <div v-if="stateSearch">
      <v-list two-line style="height: 60vh;overflow: scroll;margin-top: 10px;" v-if="listUser.length > 0">
    <template v-for="(item, index) in listUser" >
      <v-list-tile avatar style="padding: 0 !important;">
        <v-list-tile-avatar color="#2562af" size="40">
            <span class="white--text headline" v-if="!item.profile_picture">
              {{(item['display_name'].length>=2)? item['display_name'].charAt(0)+item['display_name'].charAt(1):item['display_name'].charAt(0)}}</span>
            <img :src="backend + item.profile_picture" v-else />
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title class="CSChatThai" v-text="item['display_name']"></v-list-tile-title>
          <v-list-tile-sub-title class="CSChatThai" >
            {{item['email']}}
          </v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-action>
                <span  style="color: gray; font-size: 12px; padding: 5px;" v-if="item.group_status == 'pending'">
                  เชิญแล้ว
                </span>
                <span  style="color: gray; font-size: 12px; padding: 5px;" v-else-if="item.group_status == 'active'">
                  สมาชิก
                </span>
                <v-btn small icon style="background: #2663af;  margin: 0px;position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);" v-else-if="item.group_status == 'notactive'" @click="inviteUsertoGroup(item.email)">
                 <v-icon color="white" style="font-size: 12px;">fas fa-user-plus </v-icon>
                </v-btn>
        </v-list-tile-action>



      </v-list-tile>

      <v-divider v-if="index != listUser.length -1"></v-divider>
    </template>

  </v-list>

    <p v-else-if="searchText.length < 3" style="text-align: center;
    margin-top: 10px;">
    ต้องค้นหาตั้งแต่ 3 ตัวอักษรขึ้นไป
  </p>
  <p v-else style="text-align: center;
    margin-top: 10px;">
    ไม่พบเพื่อนที่ต้องการค้นหา
  </p>
  </div>
  <p v-else style="text-align: center;
    margin-top: 10px;">
    ค้นหาเพื่อนของคุณ จากอีเมลหรือชื่อ
  </p>



  </v-flex>
    
  </v-layout>
  </div>



    </v-card-text>

</v-card>
</v-dialog>
</template>
<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { Decode } from '@/services'
var _ = require('lodash')

const query_memberInroom = gql`
query MyQuery($room_id: uuid) {
  member(where: {room_id: {_eq: $room_id}}) {
    room_id
    member_id
    status
    user {
      profile_picture
      status
      display_name
      email
      user_id
    }
  }
}
`

export default {
  props: {dialogGroupMember: false, room_id:''},
  data () {return {
    user_id: '',
    backend: process.env.VUE_APP_API,
    Authorization: {},
    Groupname: '',
    groupMember: [],
    pendingMember: [],
    state: 'show',
    listUser: [],
    searchText: '',
    stateSearch: false
  }},
  created () {
    this.user_id = Decode.decodeToken(localStorage.getItem('user_id'))
    this.Authorization = {headers: {'Authorization': 'Bearer ' + Decode.decodeToken(localStorage.getItem('auth_token'))}}

  },
  watch: {
    dialogGroupMember () {
      if(this.dialogGroupMember) {
        this.getMember()
      } else {
        this.state = 'show'
      }
    }
  },
  methods: {
    searchUser () {
      this.stateSearch = true
      if (this.searchText.length >= 3) {
        var reqestBody = { email: this.searchText, onemail_token: Decode.decodeToken(localStorage.getItem('onemail_token')), room_id: this.room_id }
        this.axios.post(process.env.VUE_APP_API + '/searchFriendInGroup', reqestBody, this.Authorization).then((response) => {
          // console.log(response.data)
          this.listUser = response.data //ไม่เท่ากับสมาชิกในกลุ่ม
        })
      } else if (this.searchText.length == 0) {
        this.stateSearch = false
      }
    },
    inviteUsertoGroup (user_id) {
      this.$swal({
        text: 'คุณต้องการเพิ่มเพื่อนเข้ากลุ่มใช่หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่ใช่',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          var reqestBody = { room_id: this.room_id, group_member: [user_id] }
          this.axios.post(process.env.VUE_APP_API + '/invitedUserToGroup', reqestBody, this.Authorization).then((response) => {
            this.state = 'show'
            this.getMember()
          }).catch((error) => {
            this.state = 'show'
            // this.countgroupMember()
            // this.countPendingMember()
            // this.room_id = this.MemberuserDetail[0].room_id
          })
        }
      })
    },
    clearState_back () {
      this.state = 'show'
    },
    changestate () {
      this.state = 'editinvite'

    },
    memberInroom () {
      subscription_memberInroom
    },
    getMember () {
      this.$apollo.query({
        query: query_memberInroom,
        variables: {
          room_id: this.room_id
        },
        fetchPolicy: 'no-cache'
      }).then((response) => {
        this.countgroupMember(response.data.member)
        this.countPendingMember(response.data.member)
      })
    },
    countgroupMember (data) {
      this.groupMember = _.partition(data, function(o) { return o.status == 'active' })[0]
    },
    countPendingMember (data) {
      this.pendingMember = _.partition(data, function(o) { return o.status == 'pending' })[0]
    },
    closeDialog () {
      this.$emit('closeDetailMember', false)
    },
    removePendingFriendGroup (user_id) {
      this.$swal({
        text: 'คุณต้องการยกเลิกการเชิญเพื่อนเข้ากลุ่มใช่หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่ใช่',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          var reqestBody = {
            "room_id": this.room_id,
            "user_id": user_id
          }
          this.axios.post(process.env.VUE_APP_API + '/removeUserPendingInGroup', reqestBody, this.Authorization).then((response) => {
            if(response.data.message === 'success') {
              this.pendingMember = _.remove(this.pendingMember, function(o) { return o.user.user_id !== user_id })
            }
          })
        }
      })
    },
    removeFriendGroup (user_id) {
      this.$swal({
        text: 'คุณต้องการลบเพื่อนออกจากกลุ่มใช่หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่ใช่',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          var reqestBody = {
            "room_id": this.room_id,
            "user_id": user_id
          }
          this.axios.post(process.env.VUE_APP_API + '/removeUserInGroup', reqestBody, this.Authorization).then((response) => {
            if(response.data.message === 'success') {
              this.groupMember = _.remove(this.groupMember, function(o) { return o.user.user_id !== user_id })
            }
          })
        }
      })
    }
  }
}
</script>
<style type="text/css" scoped>
>>>.v-dialog {
  width: 95vw;
  margin: 0 !important;
  box-shadow: none;
}

>>>.v-text-field--solo input {
    margin: auto !important;
    margin-top: auto !important;
}
>>>.v-text-field--solo>.v-input__control>.v-input__slot {
    background: #3978c7 !important;
    border-radius: 38px !important;
}

>>>.v-input input:focus .v-text-field .v-input__prepend-inner {
  color: red;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none;
  font-size: 15px;
}

>>>.theme--light.v-input:not(.v-input--is-disabled) input {
    color: #2562af !important;
}


.v-text-field--box .v-input__slot, .v-text-field--solo .v-input__slot {
  height: 30px;
}


>>>.v-text-field--solo input {
    margin: auto !important;
    margin-top: auto !important;
}
>>>.v-text-field--solo>.v-input__control>.v-input__slot {
    background: #f3f3f3 !important;
    border-radius: 5px !important;
    border: 2px solid #2562af !important;
}

>>>.v-input input:focus .v-text-field .v-input__prepend-inner {
  color: red;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none;
}
.btnSave {
  color: white !important;
  background: #2562af !important;
  box-shadow: none !important;
  margin: 20px auto !important;
  display: flex !important;
}

.profileBG_White {
  margin-right: 5px;
  height: 35vw !important;
  width: 35vw !important;
  background: #2562af !important;
  color: white;
  cursor: pointer;
  display: flex;
  margin: auto;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.HeadersDetail {
  margin-bottom: 0 !important;
  color: #5b8cbd8c;
  font-size: 11px; 
}
.Detail {
  color: #5b8cbd;
  font-size: 16px;
}
>>>.v-list--two-line .v-list__tile {
    padding: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/mail/Detail/detail_memberGroup.vue